<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            :rounded="rounded"
            :standout="standout"
            :flat="flat"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            :use-input="false"
            @input="$emit('input', $event)"
        >
            <template v-slot:selected
                v-if="showMax && multiple && $attrs && $attrs.value && $attrs.value.length>parseInt(showMax)"
            >
                <span>{{ $attrs.value.length }} éléments sélectionnés</span>
            </template>
            <template v-slot:no-option
            >
                <q-item>
                    <Input
                        v-model="searchText"
                        :dark="$attrs.dark"
                        placeholder="Filtrer"
                        class="full-width c-select-filter-input"
                        autofocus
                        :filled="false"
                        dense
                        flat
                        borderless
                    />
                </q-item>
            </template>
            <template v-slot:before-options
            >
                <q-item>
                    <Input
                        v-model="searchText"
                        :dark="$attrs.dark"
                        placeholder="Filtrer"
                        class="full-width c-select-filter-input"
                        autofocus
                        :filled="false"
                        dense
                        flat
                        borderless
                    />
                </q-item>
            </template>
        </q-select>
        <!-- <q-select
            v-bind="$attrs"
            :outlined="outlined"
            :rounded="rounded"
            :standout="standout"
            :flat="flat"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            use-input
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:selected
                v-if="showMax && multiple && $attrs && $attrs.value && $attrs.value.length>parseInt(showMax)"
            >
                <span>{{ $attrs.value.length }} éléments sélectionnés</span>
            </template>
        </q-select> -->
    </div>
</template>

<script>
    import { TAGS/*, TAGSSEARCH*/ } from '@/graphql/tag/queries'
    import QSelect from 'quasar'
    // import uniqBy from 'lodash/uniqBy'

    export default {
        name: 'TagInput',
        extends: QSelect,
        data(){
            return{
                searchTO: {},
                searchText: '',
                tagsFiltered: []
            }
        },
        props: {
            tagType: {
                type: String,
                default: 'PROFESSION'
            },
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            rounded: {
                type: Boolean,
                default: false
            },
            standout: {
                type: Boolean,
                default: false
            },
            flat: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            showMax: {
                type: [Boolean, Number, String],
                default: false
            },
            userGroups: {
                type: Array,
                default: null
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            }
        },
        // mounted(){
        // },
        computed: {
            menuItems() {
                if(this.$apollo.queries.tags && !this.$apollo.queries.tags.loading) return this.tagsFiltered
                return new Array();
            }
        },
        watch: {
            searchText: function(){
                if(this.searchText.trim()==""){
                    this.tagsFiltered=this.tags
                }else{
                    let tags=this.tags;
                    tags = tags.filter(item => item.name.toLowerCase().search(this.searchText.toLowerCase())!==-1);
                    this.tagsFiltered=tags
                }
            }
        },
        apollo: {
            tags: {
                query: TAGS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    return {type: this.tagType}
                },
                update(data) {
                    data.tags.forEach(function(tag){
                        tag.label=tag.name;
                    })
                    this.tagsFiltered=data.tags

                    setTimeout(function(){
                        this.$refs.myInput.refresh();
                    }.bind(this), 200)

                    return data.tags
                },
            }
        }
    }

</script>

<style lang="scss" scoped>
    .userProfiles {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }
</style>